import { tv } from "tailwind-variants";

/**
 * Returns a bg class for a calendar event.
 * Numeric colors (0–9) are assigned per practitioner role.
 * Named colors represent semantic appointment statuses.
 */
export const calendarEventVariants = tv({
  variants: {
    color: {
      0: "bg-calendar-0",
      1: "bg-calendar-1",
      2: "bg-calendar-2",
      3: "bg-calendar-3",
      4: "bg-calendar-4",
      5: "bg-calendar-5",
      6: "bg-calendar-6",
      7: "bg-calendar-7",
      8: "bg-calendar-8",
      9: "bg-calendar-9",
      cancelled: "bg-red-400",
      busy: "bg-orange-400",
      available: "bg-green-400",
      free: "bg-emerald-200",
    },
  },
});
